<template>
  <div id="app" :class="{'is-focus-key': isKeyboardFocussed}">
    <RouterView />
    <SvgSprites/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SvgSprites from '@/components/SvgSprites'

export default {
    name: 'app',
    components: {
        SvgSprites
    },
    data() {
        return {
            animationFrameID: null,
            appHeight: null,
            appHeightResizedTimeout: null,
            isKeyboardFocussed: false,
            lastFocussedTime: new Date().getTime()
        }
    },
    methods: {
        ...mapActions('app', [
            'setMetadata'
        ]),
        getCookie(name) {
            const regex = new RegExp(name + '=([^;]*)(;|$)')
            const matchedCookie = regex.exec(document.cookie)
            return (matchedCookie !== null && matchedCookie[1]) ? unescape(matchedCookie[1]) : null
        },
        registerEventListener() {
            document.querySelector('body').addEventListener('keydown', this.toggleKeyboardFocussed)

            document.querySelector('body').addEventListener('click', this.toggleKeyboardFocussed)
        },
        unRegisterEventListener() {
            document.querySelector('body').removeEventListener('keydown', this.toggleKeyboardFocussed)

            document.querySelector('body').removeEventListener('click', this.toggleKeyboardFocussed)
        },
        toggleKeyboardFocussed(e) {
            const currentTime = new Date().getTime()
            if (e.type === 'keydown' && e.key === 'Tab') {
                this.isKeyboardFocussed = true
                this.currentFocussedElem = e.target
            } else if (e.type === 'click' && (currentTime - this.lastFocussedTime >= 500)) {
                this.isKeyboardFocussed = false
            }
            this.lastFocussedTime = currentTime
        }
    },
    mounted() {
        const cookieCampID = this.getCookie('campID')
        if (cookieCampID !== null) {
            this.setMetadata({
                campID: cookieCampID
            })
        }
        this.registerEventListener()
    },
    created() {
        document.title = this.$i18n.t('general:title')
    },
    destroyed() {
        window.cancelAnimationFrame(this.animationFrameID)
        this.unRegisterEventListener()
    }
}
</script>

<style lang="scss">
@import "assets/scss/app";
</style>
